// Type definitions for vendor priority and distribution components

// Vendor priority interfaces
export interface IVendorPriority {
    id: number;
    vendorType: number;  // KIT(0) or PHLEBOT(1)
    vendorId: number;    // PATHTEC(0), DS2(1), etc.
    entityType: number;  // DASH(0), HOME_BLOOD_DRAW(1), etc.
    odds: number;        // Out of 100
    dateUpdated: Date;
}

export interface IVendorPriorityGroup {
    vendorType: number;
    entityType: number;
    priorities: IVendorPriority[];
}

export interface IVendorPriorityModalProps {
    show: boolean;
    vendorPriorities: IVendorPriority[];
    shipVendors: { id: number; description: string; }[];
    isLoading: boolean;
    onCancel: () => void;
    onSave: (priorities: IVendorPriority[]) => Promise<void>;
}

// Distribution modal interfaces
export interface IVendorDistribution {
    id: number;
    vendorId: number;
    name: string;
    odds: number;
}

export interface IEditDistributionModalProps {
    show: boolean;
    entityName: string;
    distributions: IVendorDistribution[];
    onSave: (distributions: IVendorDistribution[]) => void;
    onCancel: () => void;
}